import React, { useEffect, useState, createContext } from "react";
import { Row } from "react-bootstrap";
import "./App.css";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import styled, { ThemeProvider } from "styled-components";
import { useTheme } from "./themes/useTheme";
import { useChartTheme } from "./themes/useChartTheme";
import ThemeSelector from "./themes/theme_selector_component/ThemeSelector";
import Accordion from "react-bootstrap/Accordion";
import { Button } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { useAuth } from "./context/AuthProvider";
import { useNavigate } from "react-router-dom";
import themes from "./themes/themes.json";
import chart_themes from "./themes/chartThemes.json";
import { getFromLS, setToLS } from "./utils/storage";
import { ThreeCircles } from "react-loader-spinner";
import { logout } from "./utils";
import { GlobalStyles } from "./themes/GlobalStyles";
import { applyCssVars } from "./themes/useTheme";

export const AppContext = createContext(null);
const Themer = styled.div` margin: 0 !important; `;

const AppWrapper = () => {
    const navigate = useNavigate();
    const id = localStorage.getItem("firmId");
    const user = localStorage.getItem("username");
    const firstName = localStorage.getItem("firstname") || "";
    const lastName = localStorage.getItem("lastname") || "";
    const active_features = localStorage.getItem("active-features") || "";
    const { setMode, theme, themeLoaded } = useTheme();
    const { setChartMode, chartTheme, chartThemeLoaded } = useChartTheme();

    // 1) SYNC DEFAULTS FOR FIRST PAINT (no flashes)
    useEffect(() => {
        // Sync default themes for login / pre-login pages
        setMode(themes.data["calm"]);
        setChartMode(chart_themes.data["Tableau Classic 10"]);

        // Cache fallback catalogs (so ThemeSelector can open even pre-login)
        setToLS("all-themes", themes.data);
        setToLS("chart-themes", chart_themes.data);
    }, []);

    // ROUTING GUARD
    useEffect(() => {
        const publicPaths = ["/dashboard"];

        if (!localStorage.getItem("username") && publicPaths.includes(window.location.pathname)) {
            navigate("/login");
        }
    }, [navigate]);

    useEffect(() => {
        applyCssVars(theme);
    }, [theme]);

    // Overlays and ThemeSelector glue (kept minimal)
    const [isLoading, setLoading] = useState(false);
    const ThemeComponent = () => (
        !isLoading ? (
            <div>
                <Row className="show-grid">
                    <ThemeSelector
                        onSelectTheme={(t) => {
                            setMode(t);
                            setToLS("theme", t);
                        }}
                        onSelectChartTheme={(ct) => {
                            setChartMode(ct);
                            setToLS("chart-theme", ct);
                        }}
                    />
                </Row>
            </div>
        ) : (
            <div className="center-loader">
                <p>Applying your theme. Please wait a moment.</p>
                <ThreeCircles height="100" width="100" color="#4fa94d" visible />
            </div>
        )
    );

    function openNav() { document.getElementById("myNav")?.style && (document.getElementById("myNav").style.height = "100%"); }
    function closeNav() { document.getElementById("myNav")?.style && (document.getElementById("myNav").style.height = "0%"); }
    const handleLogout = () => logout();
    const clearCache = () => { localStorage.clear(); sessionStorage.clear(); window.location.reload(); };

    // 5) Render with ThemeProvider always on (login included)
    return (
        <>
            {themeLoaded && (
                <ThemeProvider theme={theme} chartTheme={chartTheme}>
                    <GlobalStyles />
                    <Themer>
                        {id && user ? (
                            <div>
                                <div id="myNav" className="nav-overlay">
                                    <a className="closebtn" onClick={closeNav}>&times;</a>
                                    <div className="nav-overlay-content">
                                        {active_features.includes("THMS") && (
                                            <Accordion style={{ border: 0, padding: 0 }} defaultActiveKey="0">
                                                <Accordion.Item eventKey="0">
                                                    <Accordion.Header>
                                                        <Icon.PaletteFill className="accordian-icons" />&nbsp;&nbsp;Theme Settings
                                                    </Accordion.Header>
                                                    <Accordion.Body style={{ minHeight: 500, maxHeight: 575, overflowY: "auto" }}>
                                                        <ThemeComponent />
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                        )}
                                        <div className="cache">
                                            <Accordion.Header>
                                                <Button variant="secondary" className="custom-button" onClick={handleLogout} style={{ width: "50%", borderRadius: 0 }}>
                                                    <Icon.DoorClosedFill className="accordian-icons" /> Logout
                                                </Button>
                                                <OverlayTrigger
                                                    delay={{ hide: 450, show: 300 }}
                                                    overlay={(p) => <Tooltip {...p}>Clear cache and hard reload</Tooltip>}
                                                    placement="bottom"
                                                >
                                                    <Button variant="secondary" className="custom-button cacheone" onClick={clearCache} style={{ width: "50%", borderRadius: 0, margin: 0 }}>
                                                        <Icon.ArrowCounterclockwise className="accordian-icons" /> Clear cache
                                                    </Button>
                                                </OverlayTrigger>
                                            </Accordion.Header>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ position: "relative", cursor: "pointer" }}>
                                    <div className="new-nav flex-row-center-center" onClick={openNav}>
                                        <div className="profile-icon">
                                            <Icon.PersonCircle className="firm-logo" />
                                        </div>
                                        <div className="user-role-name profile-full-section">
                                            {firstName} {lastName}
                                            <br />
                                            <div style={{ fontSize: "10px" }}>{(localStorage.getItem("usertype") || "").toUpperCase()}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        <App activeFeatures={active_features} />
                    </Themer>
                </ThemeProvider>
            )}
        </>
    );
};

export default AppWrapper;
